/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons/index.js";
import PrimaryButton from "../../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import ApprovalTopNavComponent from "../../../../../components/_utils/CommonTopNav/ApprovalTopNav/index.jsx";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount.js";
import PaginationComponent from "../../../../../components/_utils/PaginationComponent/index.jsx";
import InternalAccountDetailsPopup from "../../../../../components/Accounts/InternalAccount/InternalAccountDetailsPopup/index.jsx";
import Loader from "../../../../../components/Loader/Index.jsx";
import ScheduleInternalTransactionDetailPopup from "../../../../../components/Transactions/ScheduleInternalTransaction/ScheduleInternalTransactionDetailPopup/index.jsx";
import ScheduleInternalTransactionMultiApprovalCards from "../../../../../components/Transactions/ScheduleInternalTransaction/ScheduleInternalTransactionMultiApprovalCards/index.jsx";
import { getAllInternalAccounts } from "../../../../../redux/features/accounts/internalAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { ownerAccountsViewAll } from "../../../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import { scheduledInternalViewAll } from "../../../../../redux/features/transactions/scheduleInternalTransactions/index.js";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider.js";
import { standardAccountNumberFormat } from "../../../../../utils/standardAccountNumberFormat.js";
import useMultiSelect from "../../../../../utils/useMultiSelect.js";

const ScheduleInternalTransactionMultiSelect = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filterRef = useRef(null);

  const [, setIsOpen] = useState(false);
  const [active, setActive] = useState("");
  const [inputData, setInputData] = useState([]);
  const [searchdata, SetsearchData] = useState("");
  const [ownerAccId, setOwnerAccId] = useState("");
  const [ownerAccNo, setOwnerAccNo] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [formatedData, setFormatedData] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [internalAccId, setInternalAccId] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [internalAccNo, setInternalAccNo] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [txnAmountFilter, setTxnAmountFilter] = useState("");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [transactionData, setTransactionData] = useState([]);
  const [selectedCardIds, setSelectedCardIds] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [selectedPageValue, setSelectedPageValue] = useState(50);
  const [internalScheduleId, setInternalScheduleId] = useState("");
  const [internalAccIdFilter, setInternalAccIdFilter] = useState("");
  const [paymentMethodFilter, setPaymentMethodFilter] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [isAdditionalPopupOpen, setIsAdditionalPopupOpen] = useState("");
  const [frequencyMethodfilter, setFrequencyMethodfilter] = useState("");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [scheduleIntTxnLoading, setscheduleIntTxnLoading] = useState(false);
  const [selectedSendTransactions, setSelectedSendTransactions] = useState([]);
  const [confidentialMethodFilter, setConfidentialMethodFilter] = useState("");
  const [labelSearchText, setLabelSearchText] = useState([]);
  const [availableLabels, setAvailableLabels] = useState([]);
  const [internalAccDetailPopOpen, setInternalAccDetailPopOpen] =
    useState(false);

  const MAX_SELECTION_SIZE = GlobalConfiguration.categorymaxLength;

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { scheduledInternalViewLoading } = useSelector(
    (state) => state.scheduleInternalTransactions,
  );

  const { handleSelectAll: handleMultiSelectAll } = useMultiSelect();

  const approvedAccounts =
    formatedData?.filter(
      (item) => item?.internal_account_approval_status === "approved",
    ) || [];

  const formatDate = (date) => {
    const day = String(date.getDate())?.padStart(2, "0");
    const month = String(date.getMonth() + 1)?.padStart(2, "0");
    const year = date?.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const fetchData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Internal account": {
          const searchString = String(searchUserTextDebounce || "").trim();
          if (!searchString) {
            data = [];
            break;
          }

          const numericOnly = searchString.replace(/\D/g, "");
          const internalParams =
            numericOnly.length >= GlobalConfiguration.accountminLength
              ? {
                  page_no: GlobalConfiguration.lengthCheckOne,
                  page_size: GlobalConfiguration.panLength,
                  bank_account_no: numericOnly,
                  type: "internalAccount",
                }
              : {
                  page_no: GlobalConfiguration.lengthCheckOne,
                  page_size: GlobalConfiguration.panLength,
                  search_string: searchString,
                  type: "internalAccount",
                };

          response = await dispatch(getAllInternalAccounts(internalParams));

          data =
            response?.payload?.internal_accounts?.map((itm) => ({
              id: itm.id,
              display: itm.name
                ? `${itm.bank_acc_no || ""} - ${itm.name}`
                : itm.bank_acc_no || itm.id,
              bank_account_no: itm.bank_acc_no,
              name: itm.name,
              ifsc_code: itm.ifsc_code,
              email_id: itm.email_id,
            })) || [];
          break;
        }
        case "Search":
          SetsearchData(searchUserTextDebounce);
          break;

        case "Owner account": {
          const searchString = String(searchUserTextDebounce || "").trim();
          if (!searchString) {
            data = [];
            break;
          }

          const numericOnlyOwn = searchString.replace(/\D/g, "");
          const ownerParams =
            numericOnlyOwn.length >= GlobalConfiguration.accountminLength
              ? {
                  page_no: GlobalConfiguration.lengthCheckOne,
                  page_size: GlobalConfiguration.panLength,
                  bank_account_no: numericOnlyOwn,
                }
              : {
                  page_no: GlobalConfiguration.lengthCheckOne,
                  page_size: GlobalConfiguration.panLength,
                  search_string: searchString,
                };

          response = await dispatch(ownerAccountsViewAll(ownerParams));
          data =
            response?.payload?.owner_accounts?.map((itm) => ({
              id: itm.id,
              display: itm.name
                ? `${itm.bank_acc_no || ""} - ${itm.name}`
                : itm.bank_acc_no || itm.id,
              bank_account_no: itm.bank_acc_no,
              name: itm.name,
              ifsc_code: itm.ifsc_code,
              email_id: itm.email_id,
            })) || [];
          break;
        }

        case "Labels": {
          const q = String(searchUserTextDebounce || "").toLowerCase();
          data = (availableLabels || [])
            .filter((l) => l.toLowerCase().includes(q))
            .map((l) => ({ id: l, Label: l }));
          break;
        }
        default:
          data = [];
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  useEffect(() => {
    const available = transactionData?.summary?.available_labels;
    if (Array.isArray(available)) setAvailableLabels(available);
  }, [transactionData]);

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active, searchUserTextDebounce]);

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const handleStartDateChange = (date) => {
    setStartDateFilter(date);
  };

  const handleEndDateChange = (date) => {
    setEndDateFilter(date);
  };

  //thunk function
  const handleAction = async () => {
    try {
      setscheduleIntTxnLoading(true);

      let queryParams = {
        page_no: currentPage,
        page_item_count: selectedPageValue,
        lifecycle_status: "pending",
      };

      if (searchdata && searchdata !== "") {
        queryParams.scheduled_name = searchdata;
      }

      if (frequencyMethodfilter && frequencyMethodfilter !== "") {
        queryParams.frequency = frequencyMethodfilter;
      }

      if (startDateFilter && startDateFilter !== "") {
        queryParams.transaction_start_date = formatDate(startDateFilter);
      }

      if (endDateFilter && endDateFilter !== "") {
        queryParams.transaction_end_date = formatDate(endDateFilter);
      }
      if (paymentMethodFilter && paymentMethodFilter !== "") {
        queryParams.payment_method = paymentMethodFilter;
      }
      if (confidentialMethodFilter && confidentialMethodFilter !== "") {
        queryParams.confidential_transaction = confidentialMethodFilter;
      }

      if (txnAmountFilter && txnAmountFilter > 0) {
        queryParams.amount = txnAmountFilter;
      }

      if (internalAccIdFilter && internalAccIdFilter !== "") {
        queryParams.internal_account_id = internalAccIdFilter;
      }

      if (ownerAccId && ownerAccId !== "") {
        queryParams.owner_account_id = ownerAccId;
      }

      if (labelSearchText?.length) {
        queryParams.labels = labelSearchText;
      }

      const response = await dispatch(scheduledInternalViewAll(queryParams));
      const newData = response?.payload?.transactions || [];

      const formattedData =
        newData?.map((account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
        })) || [];

      setTransactionData(response?.payload);
      setFormatedData(formattedData);
    } catch (error) {
      console.error("Error in API call:", error);
      setTransactionData([]);
      setFormatedData([]);
    } finally {
      setscheduleIntTxnLoading(false);
    }
  };

  const handleSelectAllCard = () => {
    const approvedWithIds = approvedAccounts.map((account) => ({
      ...account,
      id: account?.txn_id,
    }));
    handleMultiSelectAll(
      selectedSendTransactions,
      setSelectedSendTransactions,
      MAX_SELECTION_SIZE,
      approvedWithIds,
    );
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    setSelectedCardIds(
      selectedSendTransactions?.map((item) => item?.txn_id || item?.id) || [],
    );
  }, [selectedSendTransactions]);

  const closeBeneAccountDetailModal = () => {
    setInternalAccDetailPopOpen(!internalAccDetailPopOpen);
  };

  const closeScheduleInternalTxnModal = () => {
    setIsAdditionalPopupOpen("");
  };

  const handleChangePageSize = (value) => {
    setSelectedPageValue(value);
    setCurrentPage(1 || currentPage);
  };

  const handleFrequencyMethod = (selectedSettlement) => {
    const value = selectedSettlement.toLowerCase().replace(/ /g, "_");
    setFrequencyMethodfilter(value);
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setPaymentMethodFilter(selectedSettlement);
  };

  const handleConfidentialMethod = (selectedSettlement) => {
    setConfidentialMethodFilter(selectedSettlement);
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    handleAction();

    setIsFilterApplied(
      !(
        paymentMethodFilter === "" &&
        frequencyMethodfilter === "" &&
        confidentialMethodFilter === "" &&
        ownerAccNo === "" &&
        internalAccNo === "" &&
        startDateFilter === "" &&
        endDateFilter === "" &&
        txnAmountFilter === "" &&
        searchdata === "" &&
        !labelSearchText.length
      ),
    );
  }, [
    markerData,
    dispatch,
    selectedPageValue,
    currentPage,
    frequencyMethodfilter,
    startDateFilter,
    internalAccIdFilter,
    paymentMethodFilter,
    ownerAccId,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
    searchdata,
    labelSearchText,
  ]);

  const selectedCount =
    selectedCardIds?.length || GlobalConfiguration.lengthCheckZero;

  const selectableCount = Math.min(MAX_SELECTION_SIZE, approvedAccounts.length);

  const isMaxReached =
    selectableCount > GlobalConfiguration.lengthCheckZero &&
    selectedCount >= selectableCount;

  const selectionBtnProps = {
    btnText: "Select up to 20",
    btnType: "button",

    enabledBgColor: isMaxReached
      ? "var(--positive-bg)"
      : "var(--primary-nav-act)",

    hoverOption: isMaxReached ? "black" : "white",

    enabledTextColor: "var(--text-primary)",

    icon: isMaxReached
      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
      : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,

    handleFunction: () => {
      handleSelectAllCard();
    },
  };
  return (
    <>
      {internalAccDetailPopOpen && internalAccId !== "" ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <InternalAccountDetailsPopup
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            bene_account_id={internalAccId}
            type={"bene_account_detail_modal"}
          />
        </div>
      ) : null}

      {isAdditionalPopupOpen !== "" && internalScheduleId !== "" ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ScheduleInternalTransactionDetailPopup
            closeScheduleInternalTxnModal={closeScheduleInternalTxnModal}
            schedule_internaltxn_id={internalScheduleId}
            detailSelected={isAdditionalPopupOpen}
            typeMulti="MultiApprovalSelect"
            type={"bene_account_detail_modal"}
          />
        </div>
      ) : null}

      <div
        className={`flex flex-col h-screen relative overflow-hidden ${showInnerSearchBar ? "bg-PopUp-BackDrop" : "bg-primary-bg"}`}
      >
        <div className="w-width-full h-height-full">
          <div className="w-width-full h-height-full relative z-z-index-content flex flex-col overflow-y-hidden overflow-x-hidden">
            <div className="w-width-full h-navbar-breadcrumb-height Qmd:block hidden bg-primary-nav flex-shrink-0"></div>
            <div className="relative z-z-index-overlay">
              <ApprovalTopNavComponent
                ispagination={
                  formatedData?.length <= GlobalConfiguration.lengthCheckZero
                    ? false
                    : true
                }
                handleBack={() => navigate(-1)}
                isSelectionView={true}
                selectionText={`Transactions selected : ${selectedCardIds.length}`}
                {...(formatedData?.length >
                  GlobalConfiguration.lengthCheckZero && {
                  selectionBtnProps: selectionBtnProps,
                })}
                topNavCtaBtn2Props={{
                  inActiveVariantNeeded: true,
                  btnText: "Next",
                  btnType: "button",
                  enabledBgColor: "var(--text-primary)",
                  enabledTextColor: "var(--primary-bg)",
                  isDisabled: !selectedCardIds?.length,
                  disabledBgColor: "var(--text-disabled)",
                  disabledTextColor: "var(--text-primary)",
                  handleFunction: () => {
                    if (
                      selectedCardIds?.length >
                      GlobalConfiguration?.lengthCheckZero
                    ) {
                      sessionStorage.setItem(
                        "intSelectedScheduleCard",
                        JSON.stringify([
                          {
                            selectedDetails: selectedSendTransactions,
                            selectedIds: selectedCardIds,
                          },
                        ]),
                      );

                      navigate(
                        "/internal_transaction_dashboard/schedule_multi_approval/schedules_multi_approval",
                      );
                    }
                  },
                }}
                isToggleNeeded={true}
                toggleProps={{
                  state: false,
                  isDisabled: false,
                  title: "Single Approval",
                  handleClick: () =>
                    navigate(
                      "/internal_transaction_dashboard/schedule_single_approval",
                    ),
                }}
                iconComponentArray={[
                  {
                    icon: ICONS?.SEARCH_WHITE,
                    title: "Search",
                    hoverOption: "white",
                    isLoading: false,
                    isDisabled: scheduleIntTxnLoading,
                    enabledBgColor:
                      paymentMethodFilter?.length ||
                      frequencyMethodfilter?.length ||
                      confidentialMethodFilter?.length ||
                      startDateFilter ||
                      endDateFilter ||
                      searchdata?.length ||
                      txnAmountFilter
                        ? "var(--text-primary)"
                        : "var(--primary-bg)",
                    handleFunction: () => setShowSearchBar((prev) => !prev),
                  },
                ]}
                filteredSearchProps={{
                  setShowInnerSearchBar,
                  showSearchBar,
                  isSearchDisabled: scheduleIntTxnLoading,
                  onSearchInput: handleSearch,
                  searchText: searchUserTextDebounce,
                  searchPlaceholder: "Search schedule internal transaction",
                  filterPlaceholder: "schedule name",

                  filterItems: [
                    {
                      name: "Search",
                      isMulti: false,
                      value: searchdata,
                      setValue: SetsearchData,
                      isDropdown: false,
                      isDisabled: false,
                    },
                    {
                      name: "Internal account",
                      short_name: "Int. Acc",
                      isMulti: false,
                      value: internalAccIdFilter,
                      displayValue: internalAccNo,
                      setValue: setInternalAccIdFilter,
                      setDisplayValue: (val) => {
                        setInternalAccNo(val);
                      },
                      isDropdown: true,
                      valueType: "string",
                      isDisabled: scheduleIntTxnLoading,
                    },
                    {
                      name: "Owner account",
                      short_name: "Src. Acc",
                      isMulti: false,
                      value: ownerAccId,
                      displayValue: standardAccountNumberFormat(
                        ownerAccNo,
                        true,
                      ),
                      setValue: setOwnerAccId,
                      setDisplayValue: setOwnerAccNo,
                      valueType: "string",
                      isDropdown: true,
                      isDisabled: scheduleIntTxnLoading,
                    },
                    {
                      name: "Labels",
                      short_name: "Lab",
                      isMulti: true,
                      value: labelSearchText,
                      setValue: (val) => {
                        setCurrentPage(1);
                        setLabelSearchText(val);
                        setActive("");
                      },
                      isDropdown: true,
                      valueType: "string",
                      isDisabled: scheduleIntTxnLoading,
                    },
                    {
                      name: "Amount",
                      short_name: "Amt - INR",
                      isMulti: false,
                      value: txnAmountFilter,
                      setValue: setTxnAmountFilter,
                      displayValue: FormatAmount({ price: txnAmountFilter }),
                      isDropdown: false,
                      valueType: "number",
                      isDisabled: scheduleIntTxnLoading,
                    },
                  ],

                  filters: [
                    {
                      name: "Payment method",
                      filterType: "dropdown",
                      variant: "single",
                      options: ["NEFT", "RTGS"],
                      value: paymentMethodFilter,
                      searchPlaceholder: "Search",
                      dropdownType: "PaymentMethod",
                      dropdownPlaceHolder: "Select type",
                      handleChange: (val) => handlePaymentMethod(val),
                    },

                    {
                      name: "Schedule start date",
                      filterType: "calender",
                      variant: "single",
                      size: "small",
                      value: startDateFilter,
                      isDisable: false,
                      startDate: startDateFilter,
                      handleChange: (date) => handleStartDateChange(date),
                    },
                    {
                      name: "Schedule end date",
                      filterType: "calender",
                      variant: "single",
                      value: endDateFilter,
                      isDisable: false,
                      startDate: endDateFilter,
                      handleChange: (date) => handleEndDateChange(date),
                    },
                    {
                      name: "Frequency",
                      filterType: "dropdown",
                      variant: "single",
                      isSearch: false,
                      options: [
                        "Once",
                        "Daily",
                        "Weekly",
                        "Fortnightly",
                        "Monthly",
                        "Quarterly",
                        "Half yearly",
                        "Yearly",
                      ],
                      searchPlaceholder: "Search",
                      dropdownPlaceHolder: "Select frequency",
                      value: frequencyMethodfilter,
                      isDisable: false,
                      handleChange: (val) => handleFrequencyMethod(val),
                    },
                    {
                      name: "Show/hide confidential transactions",
                      filterType: "dropdown",
                      variant: "single",
                      isSearch: false,
                      options: ["Show only confidential", "Hide confidential"],
                      searchPlaceholder: "Search",
                      dropdownPlaceHolder: "Default (all transactions)",
                      value: confidentialMethodFilter,
                      handleChange: (val) => handleConfidentialMethod(val),
                    },
                  ],
                  isFilterClearAllDisabled: !(
                    paymentMethodFilter?.length ||
                    frequencyMethodfilter?.length ||
                    confidentialMethodFilter?.length ||
                    startDateFilter ||
                    endDateFilter ||
                    scheduleIntTxnLoading
                  ),

                  isSearchClearAllDisabled: !(
                    searchdata?.length ||
                    frequencyMethodfilter?.length ||
                    internalAccIdFilter?.length ||
                    ownerAccId?.length ||
                    paymentMethodFilter?.length ||
                    txnAmountFilter?.length ||
                    labelSearchText?.length ||
                    startDateFilter ||
                    endDateFilter ||
                    scheduleIntTxnLoading
                  ),

                  inputData,
                  active,
                  setActive,
                  loadingData: loadingData,
                  loading: false,
                  setLoading: setLoadingData,
                  isShowFilter: true,
                }}
              />
            </div>

            <div
              className={`flex flex-col flex-1 overflow-y-auto
              ${
                formatedData?.length === GlobalConfiguration.lengthCheckZero ||
                scheduleIntTxnLoading ||
                scheduledInternalViewLoading
                  ? "pb-bottom-base"
                  : "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
              }`}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
              )}
              <div
                ref={filterRef}
                className="w-width-full overflow-y-auto  h-[-webkit-fill-available] z-z-index-content scroll-py-top_md"
                style={{ overflow: showInnerSearchBar ? "hidden" : "auto" }}
              >
                {scheduleIntTxnLoading || scheduledInternalViewLoading ? (
                  <div
                    style={{
                      opacity: showInnerSearchBar
                        ? "var(--opcacity_none)"
                        : "var(--base-opacity)",
                    }}
                    className="loader-container m-auto justify-center items-center flex h-height-full"
                  >
                    <Loader />
                  </div>
                ) : !formatedData?.length ? (
                  <div className="w-full h-full flex flex-col justify-center items-center">
                    <img
                      src={
                        isFilterApplied
                          ? ICONS?.NO_DATA_FOUND
                          : ICONS?.NO_PENDING_TRANSACTION
                      }
                      alt="NoAccountRemain"
                    />
                    <div className="w-full mt-margin-md text-text-primary text-font-sm text-center">
                      {isFilterApplied
                        ? "No data found."
                        : "There are no more transactions that require your approval."}
                    </div>
                    <div className="mt-margin-md">
                      <PrimaryButton
                        btnText={
                          isFilterApplied
                            ? "Clear parameters"
                            : "Internal transaction dashboard"
                        }
                        enabledBgColor="var(--primary-act)"
                        handleFunction={() => {
                          if (isFilterApplied) {
                            setPaymentMethodFilter("");
                            setFrequencyMethodfilter("");
                            setConfidentialMethodFilter("");
                            setOwnerAccNo("");
                            setOwnerAccId("");
                            setInternalAccNo("");
                            setInternalAccIdFilter("");
                            setStartDateFilter("");
                            setEndDateFilter("");
                            setTxnAmountFilter("");
                            SetsearchData("");
                            setLabelSearchText([]);
                          } else {
                            navigate("/internal_transaction_dashboard");
                          }
                        }}
                        enabledTextColor="var(--text-primary)"
                        hoverOption="white"
                      />
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${showInnerSearchBar ? "pointer-events-none" : "flex flex-col items-center justify-center mx-auto bg-primary-bg"}`}
                    style={{
                      scrollPaddingTop: "var(--padding-md)",
                      scrollPaddingBottom: "var(--padding-md)",
                    }}
                  >
                    <div className="standard-card-alignment gap-x-gap-sm gap-y-gap-md">
                      {formatedData?.map((data, index) => {
                        return (
                          <React.Fragment key={data?.txn_id || index}>
                            <ScheduleInternalTransactionMultiApprovalCards
                              filterRef={filterRef}
                              data={data}
                              isSidebarOpenpop={showInnerSearchBar}
                              selectedCardIds={selectedCardIds}
                              setSelectedCardIds={setSelectedCardIds}
                              selectedSendTransactions={
                                selectedSendTransactions
                              }
                              setSelectedSendTransactions={
                                setSelectedSendTransactions
                              }
                              setIsAdditionalPopupOpen={
                                setIsAdditionalPopupOpen
                              }
                              setInternalAccDetailPopOpen={
                                setInternalAccDetailPopOpen
                              }
                              setInternalScheduleId={setInternalScheduleId}
                              setInternalAccId={setInternalAccId}
                            />
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              className={`flex flex-col absolute bottom-bottom-base ${showInnerSearchBar ? "opacity-light-opacity pointer-events-none" : "opacity-base-opacity"}`}
            >
              {(formatedData?.length ?? 0) !== 0 && !scheduleIntTxnLoading ? (
                <div className="z-z-index-fixed-ui w-screen">
                  <PaginationComponent
                    handleSelect={handleChangePageSize}
                    selectedValue={selectedPageValue}
                    data={transactionData}
                    pageSize={selectedPageValue}
                    dropdownOptions={[50, 100]}
                    handlePagination={handlePageChange}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleInternalTransactionMultiSelect;
